import { useField } from "formik";
import React from "react";
import { Form, Label } from "semantic-ui-react";

interface Props {
    placeholder: string;
    rows: number;
    name: string;
    showRequired?: boolean,
    readOnly?: boolean;
    maxLength?: number;
    hideTitle?: boolean;
    value?: any;
}

function TextArea(props: Props) {
    const [field, meta] = useField(props.name);
    const {showRequired, hideTitle, ...rest} = props;
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            {!hideTitle && <label htmlFor={props.name} style={{paddingBottom: "10px"}}>
                {props.placeholder} {showRequired ? '*' : '' }</label>}
            <textarea id={props.name} {...field} {...rest}  />
            {meta.touched && meta.error ? (
                <Label basic color='red' pointing='above'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export default TextArea;